export default __webpack_public_path__ + "static/media/m_engineering_card08_1.b21bf793.png";